(function () {
  function seasonalCardNames(today) {
    var year = today.getFullYear();
    var todayOnly = new Date(year, today.getMonth(), today.getDate());
    function fixed(month, day) { return new Date(year, month, day); }
    function nth(month, weekday, occurrence) {
      var first = new Date(year, month, 1);
      return new Date(year, month, 1 + (weekday - first.getDay() + 7) % 7 + (occurrence - 1) * 7);
    }
    function easter() {
      var a = year % 19, b = Math.floor(year / 100), c = year % 100;
      var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
      return new Date(year, month, ((h + l - 7 * m + 114) % 31) + 1);
    }
    var seasons = [
      { name: 'Happy Valentine’s Day', end: fixed(1, 14), months: 1 },
      { name: 'Happy Easter', end: easter(), months: 1 },
      { name: 'Happy Mother’s Day', end: nth(4, 0, 2), months: 1 },
      { name: 'Happy Father’s Day', end: nth(5, 0, 3), months: 1 },
      { name: 'Happy Thanksgiving', end: nth(9, 1, 2), months: 1 },
      { name: 'Happy Thanksgiving', end: nth(10, 4, 4), months: 1 },
      { name: 'Happy Holidays', start: fixed(9, 15), end: fixed(11, 25) }
    ];
    return seasons.filter(function (season) {
      var start = season.start ? new Date(season.start) : new Date(season.end);
      if (!season.start) start.setMonth(start.getMonth() - season.months);
      return todayOnly >= start && todayOnly <= season.end;
    }).map(function (season) { return season.name; });
  }

  function init(root) {
    var form = root.querySelector('form');
    if (!form) return;

    var amounts = form.querySelectorAll('input[name="id"]');
    var modeInputs = form.querySelectorAll('[data-gift-card-mode]');
    var availableSeasonalCards = seasonalCardNames(new Date());
    var cardChoices = form.querySelector('.yvr-gc__cards');
    var seasonalChoices = Array.from(cardChoices.querySelectorAll('[data-seasonal-card]'));
    seasonalChoices.forEach(function (card) {
      card.hidden = availableSeasonalCards.indexOf(card.dataset.seasonalCard) === -1;
    });
    // Keep the current occasions before the regular cards, with Happy Holidays first when available.
    availableSeasonalCards.sort(function (a, b) {
      return Number(b === 'Happy Holidays') - Number(a === 'Happy Holidays');
    }).reverse().forEach(function (name) {
      var card = seasonalChoices.find(function (choice) { return choice.dataset.seasonalCard === name; });
      if (card) cardChoices.prepend(card);
    });
    var modeSections = form.querySelectorAll('[data-mode-required]');
    var sendSections = form.querySelectorAll('[data-send-only]');
    var selfSections = form.querySelectorAll('[data-self-only]');
    var sendInputs = form.querySelectorAll('[data-send-only] input, [data-send-only] textarea');
    var quantityInput = form.querySelector('[data-gift-card-quantity]');
    var sendQuantity = form.querySelector('[data-send-quantity]');
    var messageInput = form.querySelector('[data-message-text]');
    var error = form.querySelector('[data-gift-card-error]');
    var submit = form.querySelector('[data-gift-card-submit]');
    var checkout = form.querySelector('[data-gift-card-checkout]');
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (cartRoot.charAt(cartRoot.length - 1) !== '/') cartRoot += '/';
    // Keep the browser's unstyleable validation popup suppressed.
    form.noValidate = true;
    var requiredFields = form.querySelectorAll('.yvr-gc__field input[required]');
    var isAdding = false;

    function selectedMode() {
      var selected = form.querySelector('[data-gift-card-mode]:checked');
      return selected ? selected.value : null;
    }

    function isDirectSend() {
      return selectedMode() === 'send';
    }

    function selectedQuantity() {
      return Number(quantityInput.value);
    }

    function updateActionLabels() {
      submit.textContent = 'Add to cart';
    }

    function clearFieldError(input) {
      var hint = input.parentElement.querySelector('[data-gift-card-field-error]');
      if (hint) hint.remove();
      input.classList.remove('input--error', 'yvr-gc__field-shake');
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }

    function showFieldError(input, message, index) {
      clearFieldError(input);
      var hint = document.createElement('span');
      hint.id = form.id + '-field-error-' + index;
      hint.className = 'yvr-gc__visually-hidden';
      hint.setAttribute('data-gift-card-field-error', '');
      hint.textContent = message;
      input.insertAdjacentElement('afterend', hint);
      input.classList.add('input--error');
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', hint.id);
      void input.offsetWidth;
      input.classList.add('yvr-gc__field-shake');
      input.addEventListener('animationend', function () {
        input.classList.remove('yvr-gc__field-shake');
      }, { once: true });
    }

    function validateFields() {
      var firstInvalid = null;
      var firstMessage = '';
      var firstIndex = -1;
      requiredFields.forEach(function (input, index) {
        clearFieldError(input);
        if (input.disabled) return;
        var missing = !input.value.trim();
        if (!missing && input.validity.valid) return;
        if (!firstInvalid) {
          firstInvalid = input;
          firstMessage = missing ? input.dataset.errorRequired : input.dataset.errorInvalid;
          firstIndex = index;
        }
      });
      if (firstInvalid) {
        showFieldError(firstInvalid, firstMessage, firstIndex);
        firstInvalid.focus();
      }
      return !firstInvalid;
    }

    requiredFields.forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.value.trim() && input.validity.valid) clearFieldError(input);
      });
    });

    function showError(message) {
      error.textContent = message;
      error.hidden = false;
      error.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    function setBusy(busy, destination) {
      isAdding = busy;
      submit.disabled = busy;
      checkout.disabled = busy;
      if (busy && destination === 'cart') submit.textContent = 'Adding to cart…';
      else updateActionLabels();
      checkout.textContent = busy && destination === 'checkout' ? 'Adding gift cards…' : 'Quick checkout';
    }

    function updateMode() {
      var mode = selectedMode();
      root.dataset.giftCardMode = mode || 'none';
      modeSections.forEach(function (section) { section.hidden = !mode; });
      sendSections.forEach(function (section) { section.hidden = mode !== 'send'; });
      selfSections.forEach(function (section) { section.hidden = mode !== 'self'; });
      sendInputs.forEach(function (input) {
        input.disabled = mode !== 'send' || !!input.closest('[data-seasonal-card][hidden]');
      });
      sendQuantity.disabled = mode !== 'send';
      quantityInput.disabled = mode !== 'self';
      requiredFields.forEach(clearFieldError);
      error.hidden = true;
      updateActionLabels();
    }

    modeInputs.forEach(function (input) { input.addEventListener('change', updateMode); });
    form.querySelector('[data-quantity-decrease]').addEventListener('click', function () {
      quantityInput.value = Math.max(1, (Number.isInteger(selectedQuantity()) ? selectedQuantity() : 1) - 1);
      updateActionLabels();
    });
    form.querySelector('[data-quantity-increase]').addEventListener('click', function () {
      quantityInput.value = Math.min(99, (Number.isInteger(selectedQuantity()) ? selectedQuantity() : 1) + 1);
      updateActionLabels();
    });
    quantityInput.addEventListener('input', updateActionLabels);
    updateMode();

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (isAdding || !selectedMode() || !validateFields()) return;
      var direct = isDirectSend();
      var quantity = direct ? 1 : selectedQuantity();
      var rawMessage = direct ? messageInput.value.trim() : '';
      var hasAmount = Array.prototype.some.call(amounts, function (input) { return input.checked; });
      if (rawMessage.length > 200 || !hasAmount || !Number.isInteger(quantity) || quantity < 1 || quantity > 99) {
        showError(rawMessage.length > 200 ? 'Please shorten your message so it fits on the gift card.'
          : !hasAmount ? 'Please choose a gift card amount.'
          : 'Choose between 1 and 99 gift cards.');
        if (!direct && (quantity < 1 || quantity > 99 || !Number.isInteger(quantity))) quantityInput.focus();
        return;
      }
      error.hidden = true;
      var destination = event.submitter === checkout ? 'checkout' : 'cart';
      setBusy(true, destination);
      var data = new FormData(form);
      data.delete('gift-card-mode');
      data.set('quantity', String(quantity));
      if (direct) data.set('properties[Message]', rawMessage);

      try {
        var addResponse = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!addResponse.ok) {
          var addError = await addResponse.json().catch(function () { return {}; });
          showError(addError.description || 'We could not add the gift card. Please try again.');
          setBusy(false);
          return;
        }

        if (destination === 'cart') {
          window.location.assign(cartRoot + 'cart');
          return;
        }

        // Recheck the whole cart after adding. Any physical product needs the cart's delivery flow.
        var cartResponse = await fetch(cartRoot + 'cart.js', { credentials: 'same-origin' });
        if (!cartResponse.ok) throw new Error('Cart could not be checked');
        var cart = await cartResponse.json();
        var giftCardsOnly = Array.isArray(cart.items) && cart.items.length > 0 &&
          cart.items.every(function (item) { return item.gift_card === true; });
        window.location.assign(giftCardsOnly ? '/checkout' : cartRoot + 'cart');
      } catch (requestError) {
        // The add request may have succeeded; show the cart instead of risking a duplicate add.
        window.location.assign(cartRoot + 'cart');
      }
    });

  }

  function start() {
    document.querySelectorAll('[data-yvr-gift-card-builder]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
